<!--
 * @Description: 潜在客户信息
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2023-06-30 11:13:31
 * @LastEditors: cxh
-->
<template>
  <a-form ref="formRef" name="advanced_search" :model="form">
    <dc-layout-card title="基本信息">
      <dc-form-item
        :name="['customerInfo', 'customerName']"
        label="客户名称"
        :rules="{
          message: '请输入',
          required: true
        }"
      >
        <CosInputTianyancha
          v-model:value="form.customerInfo.customerName"
          :view="view"
          appId="cos_lbu"
          :maxlength="50"
          :disabled="type === 'clients' && !permissionBtn.includes('lbu_clients_edit_name_or_code_btn') ? true : false"
        />
      </dc-form-item>
      <dc-form-item
        :name="['customerInfo', 'status']"
        label="状态"
        :rules="{
          message: '请选择',
          validator: selectForNumberValidate,
          required: true
        }"
      >
        <template #label>
          <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
            <template #title>
              <div v-for="item in status" :key="item.value">
                <p>{{ item.label }}：{{ item.desc }}</p>
              </div>
            </template>
            <span>状态</span>
            <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px" />
          </a-tooltip>
        </template>
        <CosSelect
          v-model:value="form.customerInfo.status"
          allowClear
          placeholder="请选择"
          :options="status"
          :view="view"
          :disabled="type === 'potential' ? true : false"
        />
      </dc-form-item>

      <dc-form-item
        label="来源渠道"
        :name="['customerInfo', 'channel']"
        :rules="{
          required: true,
          message: '请选择'
        }"
      >
        <a-input-group compact class="cos-view-input-group">
          <ParamCodeCascader
            v-model:value="form.customerInfo.channel"
            appId="cos_lbu"
            paramCode="lbu_source_channel"
            :status="view ? undefined : 0"
            style="width: 33%"
            :view="view"
            :disabled="!props.isEdit || channelDisabled"
            :cosDes="form.customerInfo.channelExplain"
          />
          <a-form-item style="width: 67%" class="last-compact" name="channelExplain">
            <CosInput
              v-model:value="form.customerInfo.channelExplain"
              :maxlength="50"
              placeholder="请输入"
              :view="view"
              :disabled="!props.isEdit || channelDisabled"
            />
          </a-form-item>
        </a-input-group>
      </dc-form-item>
      <dc-form-item label="客户负责人" v-if="disabled">
        <CosInput v-model:value="form.customerInfo.sellerName" :view="view" />
      </dc-form-item>
      <dc-form-item label="客户代码" :name="['customerInfo', 'tmsCode']">
        <CosInput
          v-model:value="form.customerInfo.tmsCode"
          :view="view"
          :maxlength="10"
          placeholder="请输入"
          :disabled="true"
        />
      </dc-form-item>
      <dc-form-item
        label="客户类型"
        :name="['customerInfo', 'type']"
        :rules="{
          message: '请选择',
          validator: selectForNumberValidate,
          required: true
        }"
      >
        <CosSelect
          v-model:value="form.customerInfo.type"
          :options="dataConfig.customerTypeEnum"
          placeholder="请选择"
          allow-clear
          :view="view"
        />
      </dc-form-item>
      <template v-if="perfect">
        <dc-form-item
          label="客户等级"
          :name="['customerInfo', 'grade']"
          :rules="{
          message: '请选择',
          validator: selectForNumberValidate,
          required: type === 'clients'
        }">
          <ParamCodesSelect
            v-model:value="form.customerInfo.grade"
            :options="paramCodeData.lbu_customer_grade"
            :view="view"
          />
        </dc-form-item>
      </template>
      <dc-form-item label="客户规模">
        <ParamCodesSelect
          :options="paramCodeData.lbu_customer_size"
          v-model:value="form.customerInfo.enterpriseScale"
          :view="view"
        />
      </dc-form-item>
      <template v-if="disabled">
        <dc-form-item label="客户识别码">
          <CosInput v-model:value="form.customerInfo.customerSerial" :view="view" placeholder="请输入" />
        </dc-form-item>
        <dc-form-item label="主账号代码">
          <CosInput v-model:value="form.customerInfo.customerNumber" :view="view" placeholder="请输入" />
        </dc-form-item>
        <dc-form-item label="ID">
          <CosInput v-model:value="form.customerInfo.cosId" :view="view" placeholder="请输入" />
        </dc-form-item>
      </template>
      <dc-form-item label="客户合同地址" :name="['customerInfo', 'customerAddress']">
        <CosInput
          v-model:value="form.customerInfo.customerAddress"
          :maxlength="200"
          :disabled="true"
          placeholder="请输入"
          :view="view"
        />
      </dc-form-item>
      <dc-form-item label="客户标签">
        <CustomerLabelCascader
          :disabled="!props.isEdit"
          :view="view"
          type="search"
          appId="cos_lbu"
          v-model:ids="form.customerInfo.labelIdList"
          :value="form.customerInfo.labelIdList"
          allowClear/>
      </dc-form-item>
      <dc-form-item label="是否上市">
        <CosRadioGroup v-model:value="form.customerInfo.listedFlag" :options="dataConfig.flagEnum" :view="view" />
      </dc-form-item>
      <dc-form-item label="结算模式" v-if="type === 'clients' && view">
        <CosSelect
          v-model:value="form.customerInfo.settlementType"
          :options="dataConfig.settlementTypeEnum"
          :disabled="true"
          placeholder="请选择"
          allowClear
          :view="view"
        />
      </dc-form-item>
      <dc-form-item label="渠道代码" v-if="type === 'clients'">
        <CosInput disabled v-model:value="form.customerInfo.tmsChannelCode" :maxlength="200" :view="view" placeholder="--"/>
      </dc-form-item>
      <dc-form-item label="业务类型" :name="['customerInfo', 'businessType']" :rules="[{
          message: '请选择',
          required: true
        }]">
        <CosSelect
          v-model:value="form.customerInfo.businessType"
          :options="dataConfig.businessTypeEnum"
          :disabled="!props.isEdit"
          placeholder="请选择"
          allowClear
          :view="view"
        />
      </dc-form-item>
      <template v-if="disabled">
        <dc-form-item name="customerRegion" label="客户区域">
          <CustomerAreaCascader appId="cos_lbu" v-model:value="form.customerInfo.customerRegion" :view="view" />
        </dc-form-item>
        <dc-form-item label="剩余跟进天数">
          <CosInput v-model:value="form.customerInfo.remanentFollowDays" :view="view" placeholder="请输入" />
        </dc-form-item>
        <dc-form-item label="未跟进天数">
          <CosInput v-model:value="form.customerInfo.unfollowDays" :view="view" placeholder="请输入" />
        </dc-form-item>
        <dc-form-item label="创建人">
          <CosInput v-model:value="form.customerInfo.createByName" :view="view" placeholder="请输入" />
        </dc-form-item>
        <dc-form-item label="创建时间">
          <CosInput v-model:value="form.customerInfo.createTime" :view="view" placeholder="请输入" />
        </dc-form-item>
        <dc-form-item label="首次领取时间">
          <CosInput v-model:value="form.customerInfo.firstReceiveTime" :view="view" placeholder="请输入" />
        </dc-form-item>
        <dc-form-item label="最后领取时间">
          <CosInput v-model:value="form.customerInfo.lastReceiveTime" :view="view" placeholder="请输入" />
        </dc-form-item>
        <dc-form-item label="转潜在时间">
          <CosInput v-model:value="form.customerInfo.turnedPotential" :view="view" placeholder="请输入" />
        </dc-form-item>
        <dc-form-item label="转为成交时间" v-if="form.customerInfo.status > 29">
          <CosInput v-model:value="form.customerInfo.turnedTransaction" :view="view" placeholder="请输入" />
        </dc-form-item>
        <dc-form-item label="更新时间">
          <CosInput v-model:value="form.customerInfo.updateTime" :view="view" placeholder="请输入" />
        </dc-form-item>
      </template>
    </dc-layout-card>
    <dc-layout-card title="联系人信息" v-if="content.includes('contact')">
      <dc-form-item
        label="联系人姓名"
        :name="['contact', 'name']"
        :rules="[
          {
            message: '请输入',
            required: true
          },
          {
            validator: concatNameValidate
          }
        ]"
      >
        <CosInput v-model:value="form.contact.name" :view="view" :maxlength="50" placeholder="请输入" />
      </dc-form-item>
      <dc-form-item
        :name="['contact', 'mobile']"
        label="手机号"
        :rules="{ required: form.customerInfo.businessType === 1,
          validator: (rule, value) => contactValidate(rule, value, form.contact, formRef, form.customerInfo.businessType === 1)
        }"
      >
        <CosInput v-model:value="form.contact.mobile" :view="view" placeholder="请输入" />
      </dc-form-item>
      <dc-form-item
        :name="['contact', 'email']"
        label="邮箱"
        :rules="{
          validator: (rule, value) => contactValidate(rule, value, form.contact, formRef, form.customerInfo.businessType === 1)
        }"
      >
        <CosInput v-model:value="form.contact.email" :view="view" placeholder="请输入" />
      </dc-form-item>
      <dc-form-item
        :name="['contact', 'wechat']"
        label="微信号"
        :rules="{ required: form.customerInfo.businessType === 1,
          validator: (rule, value) => contactValidate(rule, value, form.contact, formRef, form.customerInfo.businessType === 1)
        }"
      >
        <CosInput v-model:value="form.contact.wechat" :view="view" placeholder="请输入" />
      </dc-form-item>
      <dc-form-item
        :name="['contact', 'qq']"
        label="QQ号"
        :rules="{
          validator: (rule, value) => contactValidate(rule, value, form.contact, formRef, form.customerInfo.businessType === 1)
        }"
      >
        <CosInput v-model:value="form.contact.qq" :view="view" placeholder="请输入" />
      </dc-form-item>
      <dc-form-item
        :name="['contact', 'tel']"
        label="固定电话"
        :rules="{
          validator: (rule, value) => contactValidate(rule, value, form.contact, formRef, form.customerInfo.businessType === 1)
        }"
      >
        <CosInput v-model:value="form.contact.tel" :view="view" placeholder="请输入" />
      </dc-form-item>
      <dc-form-item label="传真号">
        <CosInput v-model:value="form.contact.fax" :view="view" :maxlength="50" placeholder="请输入" />
      </dc-form-item>
      <dc-form-item label="性别">
        <a-radio-group v-model:value="form.contact.sex" :options="dataConfig.genderEnum" />
      </dc-form-item>
      <dc-form-item
        label="角色"
        :name="['contact', 'jobRole']"
        :rules="{
          message: '请选择',
          validator: selectForNumberValidate,
          required: true
        }"
      >
        <CosSelect
          v-model:value="form.contact.jobRole"
          :options="dataConfig.linkRoleTypeEnum"
          placeholder="请选择"
          allow-clear
          :view="view"
        />
      </dc-form-item>
      <dc-form-item
        label="职务"
        :name="['contact', 'jobDuty']"
        :rules="{
          message: '请选择',
          validator: selectForNumberValidate,
          required: true
        }"
      >
        <ParamCodesSelect
          v-model:value="form.contact.jobDuty"
          :view="view"
          :options="paramCodeData.lbu_department_title"
        />
      </dc-form-item>
      <dc-form-item
        label="备注"
        :span="12"
        name="remark"
      >
        <CosInput
          v-model:value="form.contact.remark"
          :maxlength="2000"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
    </dc-layout-card>
    <dc-layout-card title="签到地址（添加后才能签到打卡）" :span="6">
      <template #title>
        <div style="display: flex; align-items: center; height: 24px; margin-bottom: 13px">
          <div class="dc-card-header-defaut-line"></div>
          <p style="font-size: 16px; font-weight: 500">签到地址</p>
          <span style="color: #999; font-size: 12px">（添加后才能签到打卡）</span>
          <div style="flex: 1 1 0%; text-align: right">
            <a-button type="primary" ghost @click="handleAddressAdd(form.visitAddress)" v-if="!disabled">新增</a-button>
          </div>
        </div>
      </template>
      <MultipleItem :view="view" :line="false">
        <template v-for="(item, index) in form.visitAddress" :key="index">
          <dc-form-item
            :label="index ? '' : '签到地址'"
            :class="index ? 'no-form-label' : ''"
            :name="['visitAddress', index, 'addressName']"
            :rules="{
                    message: '请选择',
                    required: isEditPotentialOrDeal
                  }"
          >
            <MapModal v-model:address="item.addressName" v-model:geoPoint="item.geoPoint" :view="view"></MapModal>
          </dc-form-item>
          <dc-form-item
            :label="index ? '' : '补充地址'"
            :class="index ? 'no-form-label' : ''"
            :name="['visitAddress', index, 'suppAddress']"
            :rules="{
                    message: '请输入',
                    required: isEditPotentialOrDeal
                  }"
          >
            <CosInput v-model:value="item.suppAddress" :view="view"></CosInput>
          </dc-form-item>
          <dc-form-item
            :label="index ? '' : '地址类型'"
            :class="index ? 'no-form-label' : ''"
            :name="['visitAddress', index, 'addressTag']"
            :rules="{
                    // message: '请选择',
                    validator:  (rule:any, value:number) => checkAddressValidate(rule, value, form.visitAddress),
                    required: isEditPotentialOrDeal
                  }"
          >
            <div class="flex">
              <ParamCodesSelect
                :options="paramCodeData.lbu_sign_in_address_label"
                v-model:value="item.addressTag"
                :disabled="disabled"
                :view="view"
                allowClear
                style="width: 100%"
              />
              <a-button
                type="text"
                danger
                style="padding: 0 0 0 12px"
                v-if="!disabled && form.visitAddress && form.visitAddress.length > 1"
                @click="handleAddressAddDel(index, form.visitAddress)"
                >删除</a-button
              >
              <a-checkbox style="padding: 3px 0 0 12px; width: 150px;" :disabled="view" :checked="item.mainAddressFlag === 1" @change="clearMainAddressFlag(index)">主要</a-checkbox>
            </div>
          </dc-form-item>
          <a-col :span="6" />
        </template>
      </MultipleItem>
    </dc-layout-card>
    <dc-layout-card title="业务信息">
      <!---月潜在收入:成交客户编辑不显示--->
      <dc-form-item label="业务收入等级" :name="['business', 'monthIncome']" v-if="!perfect">
        <ParamCodesSelect
          :options="paramCodeData.lbu_important"
          v-model:value="form.business.monthIncome"
          :view="view"
        />
      </dc-form-item>
      <dc-form-item
        label="年销售GMV（元）"
        :name="['business', 'annualSales']">
        <CosInputNumber
          v-model:value="form.business.annualSales"
          cos-type="money"
          :maxlength="15"
          :min="0"
          :precision="2"
          style="width: 100%"
          placeholder="请输入"
          :view="view"
        />
      </dc-form-item>
      <dc-form-item label="总TPR（票数/月）">
        <template #label>
          <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
            <template #title>
              <p>总潜力业务量（票数/月）</p>
            </template>
            <span>总TPR（票数/月）</span>
            <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px" />
          </a-tooltip>
        </template>
        <CosInput
          v-model:value="tprPotential"
          placeholder="自动计算"
          :maxlength="100"
          :disabled="true"
          :view="view"
        />
      </dc-form-item>
      <dc-form-item label="总TPR（元/月）">
        <template #label>
          <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
            <template #title>
              <p>总潜力物流费用（元/月）</p>
            </template>
            <span>总TPR（元/月）</span>
            <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px" />
          </a-tooltip>
        </template>
        <CosInput
          v-model:value="tprTotal"
          placeholder="自动计算"
          :maxlength="100"
          cos-type="money"
          :disabled="true"
          :view="view"
        />
      </dc-form-item>
      <dc-form-item label="总TPR（KG/月）" v-if="form.customerInfo.businessType === 1">
        <template #label>
          <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
            <template #title>
              <p>总潜力重量（KG/月）</p>
            </template>
            <span>总TPR（KG/月）</span>
            <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px"/>
          </a-tooltip>
        </template>
        <CosInput
          :value="totalTprWeight"
          placeholder="自动计算"
          :maxlength="100"
          :disabled="true"
          :view="view"
        />
      </dc-form-item>
      <template v-if="view">
        <dc-form-item label="主账号上月发货票数">
          <CosInputNumber
            v-model:value="form.business.uitQty"
            cos-type="money"
            :min="0"
            :maxlength="15"
            view
          />
        </dc-form-item>
        <dc-form-item label="主账号去年上月发货票数">
          <CosInputNumber
            v-model:value="form.business.lyUitQty"
            cos-type="money"
            :min="0"
            :maxlength="15"
            view
          />
        </dc-form-item>
        <dc-form-item label="主账号前三个月平均发货票数">
          <template #label>
            <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
              <template #title>
                <p>不含上个月，即前第2到第4个月</p>
              </template>
              <span>主账号前三个月平均发货票数</span>
              <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px" />
            </a-tooltip>
          </template>
          <CosInputNumber
            v-model:value="form.business.avgQty"
            cos-type="money"
            :min="0"
            :maxlength="15"
            view
          />
        </dc-form-item>
        <dc-form-item label="当前账号上月发货票数">
          <CosInputNumber
            v-model:value="form.business.ctUitQty"
            cos-type="money"
            :min="0"
            :maxlength="15"
            view
          />
        </dc-form-item>
        <dc-form-item label="当前账号去年上月发货票数">
          <CosInputNumber
            v-model:value="form.business.ctLyUitQty"
            cos-type="money"
            :min="0"
            :maxlength="15"
            view
          />
        </dc-form-item>
        <dc-form-item label="当前账号前三个月平均发货票数">
          <template #label>
            <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
              <template #title>
                <p>不含上个月，即前第2到第4个月</p>
              </template>
              <span>当前账号前三个月平均发货票数</span>
              <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px" />
            </a-tooltip>
          </template>
          <CosInputNumber
            v-model:value="form.business.ctAvgQty"
            cos-type="money"
            :min="0"
            :maxlength="15"
            view
          />
        </dc-form-item>
        <dc-form-item label="总OPR金额">
          <CosInputNumber
            v-model:value="form.business.totalOprAmount"
            cos-type="money"
            :min="0"
            :maxlength="15"
            view
          />
        </dc-form-item>
        <dc-form-item label="总OPR票数">
          <CosInputNumber
            v-model:value="form.business.totalOprMau"
            :min="0"
            :maxlength="15"
            view
          />
        </dc-form-item>
        <dc-form-item label="总OPR重量">
          <CosInputNumber
            v-model:value="form.business.totalOprWeight"
            :min="0"
            :maxlength="15"
            view
          />
        </dc-form-item>
        <dc-form-item label="总OPR方数">
          <CosInputNumber
            v-model:value="form.business.totalOprCube"
            :min="0"
            :maxlength="15"
            view
          />
        </dc-form-item>
      </template>
    </dc-layout-card>

    <dc-layout-card title="在售平台">
      <template #subTitle>
        <a-button type="primary" ghost v-if="!disabled" @click="handleAddCol(form.business.saleInfo)">新增</a-button>
      </template>
      <MultipleItem :view="view" :line="false">
        <template v-for="(item, index) in form.business.saleInfo" :key="`saleInfo${index}`">
          <dc-form-item
            :label="index ? '' : '在售电商平台'"
            :class="[index ? 'no-form-label' : '']"
            :name="['business', 'saleInfo', index, 'salePlatformId']"
            :rules="
              perfect
                ? {
                    message: '请选择',
                    validator: selectForNumberValidate,
                    required: true
                  }
                : {
                    message: '请选择',
                    validator: (rule, value) =>
                      arrayValueValidate(rule, value, {
                        salePlatformId: item.salePlatformId,
                        percent: item.percent
                      })
                  }
            "
          >
            <ParamCodesSelect
              :options="paramCodeData.lbu_sale_platform"
              v-model:value="item.salePlatformId"
              :view="view"
              @change="onSalesSelect(item,index)"
            />
          </dc-form-item>
          <dc-form-item
            :label="index ? '' : '在售平台占比(%)'"
            :class="[index ? 'no-form-label' : '']"
            :name="['business', 'saleInfo', index, 'percent']"
            :rules="[{required: perfect, validator: (rule, value) => percentValidate(rule,value,item)}]"
          >
            <div class="flex">
              <CosInputNumber
                v-model:value="item.percent"
                placeholder="请输入"
                style="width: 100%"
                :min="0"
                @change="onSalesInput"
                :view="view"
              />
              <a-button
                type="text"
                v-if="form.business.saleInfo && form.business.saleInfo.length > 1 && !disabled"
                @click="handleDelCol(form.business.saleInfo, index)"
                danger
                style="padding: 0 0 0 12px"
                >删除</a-button
              >
            </div>
          </dc-form-item>
          <a-col :span="12" />
        </template>
      </MultipleItem>
    </dc-layout-card>
    <dc-layout-card title="目的地国家">
      <template #subTitle>
        <a-button type="primary" ghost @click="handleAddCol(form.business.demandInfo)" v-if="!disabled">新增</a-button>
      </template>
      <MultipleItem :view="view" :line="false">
        <template v-for="(item, index) in form.business.demandInfo" :key="`demandInfo${index}`">
          <dc-form-item
            :label="index ? '' : '目的地国家'"
            :class="[index ? 'no-form-label' : '']"
            :name="['business', 'demandInfo', index, 'countryId']"
            :span="4"
            :rules="{
                    message: '请选择',
                    validator: selectForNumberValidate,
                    required: perfect
                  }"
          >
            <ParamCodesSelect
              :options="paramCodeData.lbu_demand_country"
              v-model:value="item.countryId"
              :view="view"/>
          </dc-form-item>
          <dc-form-item :label="index ? '' : '出货渠道'"
                        :class="index ? 'no-form-label' : ''"
                        :name="['business', 'demandInfo', index, 'shippingChannel']"
                        :span="4"
                        :rules="{
                    message: '请选择',
                    validator: selectForNumberValidate,
                    required: perfect
                  }">
            <ParamCodesSelect
              v-model:value="item.shippingChannel"
              :options="paramCodeData.lbu_shipping_channel"
              :view="view"
              mode="multiple"
            />
          </dc-form-item>
          <dc-form-item
            :label="index ? '' : 'TPR（票数/月）'"
            :class="[index ? 'no-form-label' : '']"
            :name="['business', 'demandInfo', index, 'potentialBusinessVolume']"
            :span="4"
            :rules="{
                    message: '请输入',
                    required: perfect
                  }"
          >
            <template #label>
              <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
                <template #title>
                  <p>潜力业务量（票数/月）</p>
                </template>
                <span>{{ `${index ? '' : 'TPR（票数/月）'}` }}</span>
                <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px" />
              </a-tooltip>
            </template>
            <CosInputNumber
              v-model:value="item.potentialBusinessVolume"
              :min="0"
              :maxlength="15"
              cos-type="money"
              style="width: 100%"
              placeholder="请输入"
              :view="view"
            />
          </dc-form-item>
          <dc-form-item
            :label="index ? '' : 'TPR（元/月）'"
            :class="[index ? 'no-form-label' : '']"
            :span="4"
            :name="['business', 'demandInfo', index, 'amount']"
            :rules="{
                    message: '请输入',
                    required: perfect
                  }"
          >
            <template #label>
              <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
                <template #title>
                  <p>发货潜力（元/月）</p>
                </template>
                <span>{{ `${index ? '' : 'TPR（元/月）'}` }}</span>
                <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px" />
              </a-tooltip>
            </template>
          <CosInputNumber
            v-model:value="item.amount"
            :min="0"
            :maxlength="15"
            cos-type="money"
            style="width: 100%"
            placeholder="请输入"
            :view="view"
          />
          </dc-form-item>
          <dc-form-item
            :label="index ? '' : 'TPR（KG/月）'"
            :class="index ? 'no-form-label' : ''"
            :span="6"
            :name="['business', 'demandInfo', index, 'tprWeight']"
          >
            <template #label>
              <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
                <template #title>
                  <p>发货潜力（KG/月）</p>
                </template>
                <span>{{ `${index ? '' : 'TPR（KG/月）'}` }}</span>
                <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px"/>
              </a-tooltip>
            </template>
            <div class="flex">
              <CosInputNumber
                v-model:value="item.tprWeight"
                :min="0"
                :maxlength="15"
                cos-type="money"
                :view="view"
                style="width: 100%"
              />
              <a-button
                type="text"
                v-if="form.business.demandInfo && form.business.demandInfo.length > 1 && !disabled"
                @click="handleDelCol(form.business.demandInfo, index)"
                danger
                style="padding: 0 0 0 12px"
                >删除</a-button
              >
            </div>
          </dc-form-item>
          <a-col :span="24" />
        </template>
      </MultipleItem>
    </dc-layout-card>
    <dc-layout-card title="物流商（务必填写云途份额）" :span="6">
      <template #title>
        <div style="display: flex; align-items: center; height: 24px; margin-bottom: 13px">
          <div class="dc-card-header-defaut-line"></div>
          <p style="font-size: 16px; font-weight: 500">物流商</p>
          <span style="color: #999; font-size: 12px">（务必填写云途份额）</span>
            <template v-if="props.isEdit">
                <div style="flex: 1 1 0%; text-align: right">
                    <a-button type="primary" ghost v-if="!disabled" @click="handleAddCol(form.business.logisticsProviderInfo)">新增</a-button>
                </div>
            </template>
        </div>
      </template>
      <MultipleItem :view="view" :line="false">
        <template v-for="(item, index) in form.business.logisticsProviderInfo" :key="`logisticsProviderInfo${index}`">
          <dc-form-item
            :label="index ? '' : '当前物流商'"
            :class="[index ? 'no-form-label' : '']"
            :name="['business', 'logisticsProviderInfo', index, 'currentLogisticsProvider']"
            :rules="
              perfect
                ? {
                    message: '请选择',
                    validator: selectForNumberValidate,
                    required: true
                  }
                : {
                    message: '请选择',
                    validator: (rule, value) =>
                      arrayValueValidate(rule, value, {
                        currentLogisticsProvider: item.currentLogisticsProvider,
                        percent: item.percent
                      })
                  }
            "
          >
            <ParamCodeCascader
              :options="paramCodeData.lbu_logistics_service_provider"
              v-model:value="item.currentLogisticsProvider"
              :view="view"
              @change="onLogisticsProviderSelect(item, index)"
            />
          </dc-form-item>
          <dc-form-item
            :label="index ? '' : '物流商占比(%)'"
            :class="[index ? 'no-form-label' : '']"
            :name="['business', 'logisticsProviderInfo', index, 'percent']"
            :rules="[{required: perfect, validator: (rule, value) => logisticsProviderInfoValidate(rule,value,item)}]"
          >
            <div class="flex">
              <CosInputNumber
                v-model:value="item.percent"
                placeholder="请输入"
                style="width: 100%"
                :min="0"
                @change="onLogisticsProviderInput"
                :view="view"
              />
              <a-button
                type="text"
                v-if="form.business.logisticsProviderInfo && form.business.logisticsProviderInfo.length > 1 && !disabled"
                @click="handleDelCol(form.business.logisticsProviderInfo, index)"
                danger
                style="padding: 0 0 0 12px"
                >删除</a-button
              >
            </div>
          </dc-form-item>
          <a-col :span="12" />
        </template>
      </MultipleItem>
    </dc-layout-card>

    <dc-layout-card title="货物品类">
      <template #subTitle>
        <a-button type="primary" ghost v-if="!disabled" @click="handleAddCol(form.business.goodsCategoryInfo)">新增</a-button>
      </template>
      <MultipleItem :view="view" :line="false">
        <template v-for="(item, index) in form.business.goodsCategoryInfo" :key="`goodsCategoryInfo${index}`">
          <dc-form-item
            :label="index ? '' : '货物品类'"
            :class="[index ? 'no-form-label' : '']"
            :name="['business', 'goodsCategoryInfo', index, 'goodsCategory']"
            :rules="
              perfect
                ? {
                    message: '请选择',
                    validator: selectForNumberValidate,
                    required: true
                  }
                : {
                    message: '请选择',
                    validator: (rule, value) =>
                      arrayValueValidate(rule, value, {
                        goodsCategory: item.goodsCategory,
                        percent: item.percent
                      })
                  }
            "
          >
            <ParamCodesSelect
              :options="paramCodeData.lbu_sales_category"
              v-model:value="item.goodsCategory"
              :view="view"
              @change="onGoodsCategorySelect(item,index)"
            />
          </dc-form-item>
          <dc-form-item
            :label="index ? '' : '品类占比(%)'"
            :class="[index ? 'no-form-label' : '']"
            :name="['business', 'goodsCategoryInfo', index, 'percent']"
            :rules="[{required: perfect,validator: (rule, value) => goodsCategoryInfoValidate(rule,value,item)}]"
          >
            <div class="flex">
              <CosInputNumber
                v-model:value="item.percent"
                placeholder="请输入"
                style="width: 100%"
                :min="0"
                @change="onGoodsCategoryInput"
                :view="view"
              />
              <a-button
                type="text"
                v-if="form.business.goodsCategoryInfo && form.business.goodsCategoryInfo.length > 1 && !disabled"
                @click="handleDelCol(form.business.goodsCategoryInfo, index)"
                danger
                style="padding: 0 0 0 12px"
                >删除</a-button
              >
            </div>
          </dc-form-item>
          <a-col :span="12" />
        </template>
      </MultipleItem>
    </dc-layout-card>

    <dc-layout-card title="ERP系统">
      <template #subTitle>
        <a-button type="primary" ghost @click="handleAddCol(form.business.erpInfo)" v-if="!disabled">新增</a-button>
      </template>
      <MultipleItem :view="view" :line="false">
        <template v-for="(item, index) in form.business.erpInfo" :key="`erpInfo${index}`">
          <dc-form-item
            :label="index ? '' : 'ERP系统'"
            :class="[index ? 'no-form-label' : '']"
            :name="['business', 'erpInfo', index, 'erpId']"
            :rules="
              perfect
                ? {
                    message: '请选择',
                    validator: selectForNumberValidate,
                    required: true
                  }
                : {
                    message: '请选择',
                    validator: (rule, value) =>
                      arrayValueValidate(rule, value, {
                        erpId: item.erpIdLabel,
                        erpAccount: item.erpAccount
                      })
                  }
            "
          >
            <ParamCodesSelect :options="paramCodeData.lbu_erp_info" :view="view" v-model:value="item.erpId" />
          </dc-form-item>
          <dc-form-item
            :label="index ? '' : '关联账号'"
            :class="[index ? 'no-form-label' : '']"
            :name="['business', 'erpInfo', index, 'erpAccount']"
          >
            <div class="flex">
              <CosInput v-model:value="item.erpAccount" :view="view" placeholder="请输入" />
              <a-button
                type="text"
                v-if="form.business.erpInfo && form.business.erpInfo.length > 1 && !disabled"
                @click="handleDelCol(form.business.erpInfo, index)"
                danger
                style="padding: 0 0 0 12px"
                >删除</a-button
              >
            </div>
          </dc-form-item>
          <a-col :span="12" />
        </template>
      </MultipleItem>
    </dc-layout-card>
    <dc-layout-card title="其他原因" v-if="form.customerInfo.status === 13 || form.customerInfo.status === 36">
      <template v-if="form.customerInfo.status === 13">
        <dc-form-item
          label="无效原因"
          :name="['customerInfo', 'invalidReason']"
          :span="12"
          :rules="{
            message: '请选择',
            validator: selectForNumberValidate,
            required: true
          }"
        >
          <ParamCodesSelect
            :options="paramCodeData.lbu_invalid_reason"
            v-model:value="form.customerInfo.invalidReason"
            :view="view"
          />
        </dc-form-item>
        <dc-form-item
          label="说明"
          :name="['customerInfo', 'directions']"
          :span="12"
          :rules="{
            message: '请输入',
            required: true
          }"
        >
          <CosInput v-model:value="form.customerInfo.directions" placeholder="请输入" :maxlength="200" :view="view" />
        </dc-form-item>
      </template>

      <template v-if="form.customerInfo.status === 36">
        <dc-form-item
          label="流失原因"
          :name="['customerInfo', 'loseReason']"
          :span="12"
          :rules="{
            message: '请选择',
            validator: selectForNumberValidate,
            required: true
          }"
        >
          <ParamCodesSelect
            :options="paramCodeData.lbu_loss_reason"
            v-model:value="form.customerInfo.loseReason"
            :view="view"
          />
        </dc-form-item>
        <dc-form-item
          label="具体原因"
          :name="['customerInfo', 'loseDirections']"
          :span="12"
          :rules="{
            message: '请输入',
            required: true
          }"
        >
          <CosInput
            v-model:value="form.customerInfo.loseDirections"
            placeholder="请输入"
            :maxlength="200"
            :view="view"
          />
        </dc-form-item>
      </template>
    </dc-layout-card>
    <dc-layout-card>
      <dc-form-item label="上传附件" :name="['customerInfo', 'attachmentId']" :span="24">
        <UploadFile v-model:value="form.customerInfo.attachmentId" :view="view" />
      </dc-form-item>
      <dc-form-item label="备注" :name="['customerInfo', 'remark']" :span="12">
        <CosTextarea v-model:value="form.customerInfo.remark" placeholder="请输入" :maxlength="2000" :view="view" />
      </dc-form-item>
    </dc-layout-card>
  </a-form>
  <cos-footer-button
    v-if="!disabled"
    :resetValue="resetValue"
    v-model:value="form"
    :formRef="formRef"
    :loading="loading"
    :returnName="returnName"
    @submit="handleSubmit"
    :disabled="disabled"
    :hideOk="hideOk"
    :permissionPage="permissionPage"
  >
  </cos-footer-button>
  <!--转移客户--->
</template>
<script setup lang="ts">
import { onMounted, watch, ref, PropType, reactive, computed } from 'vue'
import type { Rule } from 'ant-design-vue/es/form'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import UploadFile from '@/components/UploadFile'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import dataConfig from '@/views/yuntuSales/commonEnum/dataConfig'
import { listByParamCodes } from '@/api/common'
import MultipleItem from '@/components/CosViewContent/multipleItem.vue'
import { potentialAdd, potentialEdit, turnedDeal } from '@/api/yuntuSales/customerCenter'
import type { PotentialItem } from '@/typings/api/customerCenter'
import { DcConfirm, DcMessage, message } from '@dc-platform/dc-components'
import {
  useRoute
  // useRouter
} from 'vue-router'
import { contactValidate, concatNameValidate, arrayValueValidate, selectForNumberValidate } from '@/utils/validate'
import { cloneDeep } from 'lodash-es'
import calc from '@/utils/calc'
import { initObjectVal, paramCodesDataFilter } from '@/utils/index'
import { goBack } from '@/hooks/cosRouter'
import MapModal from '@/components/MapModal/index.vue'
import { usePermissionStore } from '@/stores/permission'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { isChannelDisabled } from '@/hooks/useChannel'
import {
  // checkAddressValidate,
  checkAddressData,
  handleAddressAdd,
  handleAddressAddDel,
  clear
} from '@/hooks/addressArrValidate'
import CosInputTianyancha from '@/components/Antd/CosInputTianyancha/index.vue'
import CosInput from '@/components/Antd/CosInput/index.vue'
import { countryChannelRelevance } from '@/api/yuntuSales/operationsManage'
import CustomerLabelCascader from '@/components/CustomerLabelCascader/index.vue'
const route = useRoute()
const permissionStore = usePermissionStore()
const permissionBtn = ref<any[]>(permissionStore.permission)
const initForm = reactive<PotentialItem>({
  business: {
    saleInfo: [{}],
    demandInfo: [{}],
    erpInfo: [{}],
    logisticsProviderInfo: [{}],
    goodsCategoryInfo: [{}]
  },
  contact: {},
  customerInfo: {},
  visitAddress: [{}]
})
const resetValue = ref(cloneDeep(initForm))
const form = ref<any>(cloneDeep(initForm))

const totalTprWeight = computed(() => {
  const result = form.value.business.demandInfo?.reduce((sum, item) => {
    return calc.Add(sum, item.tprWeight || 0)
  }, 0)
  const value = Number(result)
  if (isNaN(value)) {
    return ''
  }
  return value.toLocaleString('en-US')
})

const tprTotal = computed(() => {
  const result = form.value.business.demandInfo.reduce(
    (prev: number, item: any) => calc.Add(prev, item.amount || 0),
    0
  )
  const value = Number(result)
  if (isNaN(value)) {
    return ''
  }
  return value.toLocaleString('en-US')
})
const tprPotential = computed(() => {
  const result = form.value.business.demandInfo.reduce(
    (prev: number, item: any) => calc.Add(prev, item.potentialBusinessVolume || 0),
    0
  )
  const value = Number(result)
  if (isNaN(value)) {
    return ''
  }
  return value.toLocaleString('en-US')
})
const props = defineProps({
  disabled: {
    type: Boolean,
    default: true
  },
  view: {
    type: Boolean
  },
  data: {
    type: Object as PropType<PotentialItem>
  },
  /// 这个代表所有可编辑情况，既包含新增又包含编辑
  isEdit: {
    type: Boolean,
    required: true
  },
  /// 这个仅代表编辑
  isEditPotentialOrDeal: {
    type: Boolean,
    required: false
  },
  type: {
    type: String as PropType<'potential' | 'clients'>,
    default: 'potential' // 潜在，clients成交的基本信息 turnToDeal 转成交
  },
  permissionPage: {
    type: Object,
    default: () => {
      return {}
    }
  },
  perfect: {
    type: Boolean,
    default: false
  },
  content: {
    type: Array as PropType<'customerInfo' | 'contact' | 'business'[]>,
    default: () => {
      return ['customerInfo', 'contact', 'business']
    }
  },
  hideOk: {
    type: Boolean
  },
  returnName: String
})
watch(
  () => props.data,
  (v, prev) => {
    if (v) {
      // 转成交 ，清掉客户状态
      const formVal = v
      initObjectVal(formVal, initForm)
      if (route.path.includes('/lbu/turnToDeal')) {
        formVal.customerInfo.status = 30
      }
      form.value = formVal
      resetValue.value = cloneDeep(form.value)
    } else {
      form.value = cloneDeep(initForm)
      form.value.customerInfo.status = 10
    }
  },
  { immediate: true }
)

const clearMainAddressFlag = (index: number) => {
  if (form.value.visitAddress) {
    for (const [i, item] of form.value.visitAddress.entries()) {
      if (index === i) {
        item.mainAddressFlag = item.mainAddressFlag === 1 ? 0 : 1
      } else {
        item.mainAddressFlag = 0
      }
    }
  }
}

const checkAddressValidate = (rule: any, value: number | string, arr: any) => {
  const list = arr || []

  if (list.filter((item: any) => item.addressTag === 1223).length > 1) {
    return Promise.reject(new Error('地址类型【总部（决策地）】只能选择1个'))
  }

  if (!rule.required) {
    return Promise.resolve()
  }
  const defaultVal = -9
  if (value == null || value === '' || value === defaultVal || value === rule.filterVal) {
    return Promise.reject(new Error('请选择'))
  } else {
    return Promise.resolve()
  }
}

const percentValidate = async (rule: Rule, value: number, item: any) => {
  if (props.perfect) {
    if ((value == null || value === 0)) {
      return Promise.reject(new Error('请输入在售平台占比'))
    }
  } else {
    if (value == null || value === 0) {
      return (item.salePlatformId && item.salePlatformId !== -9) ? Promise.reject(new Error('请输入在售平台占比')) : Promise.resolve()
    }
  }
  if (value == null || value === 0) {
    return Promise.reject(new Error('请输入在售平台占比'))
  }
  let result = 0
  if (form.value.business && form.value.business.saleInfo) {
    result = form.value.business?.saleInfo.reduce(
      (prev: number, curr: any) => calc.Add(prev, Number(curr.percent) || 0),
      0
    )
  }
  if (value && result !== 100) {
    return Promise.reject(new Error('在售平台占比总和等于100%'))
  } else {
    return Promise.resolve()
  }
}
const onSalesSelect = async (item: any, index: any) => {
  if (item.salePlatformId === null || item.salePlatformId === -9) {
    formRef.value?.validate([['business', 'saleInfo', index, 'percent']])
  }
}
/// 用来校验多个列表的输入框加起来要等于100之后让validator提示消失
const onSalesInput = async () => {
  const salesList = form.value.business.saleInfo
  const validList = salesList?.map((item: any, index: number) => {
    if (item.salePlatformId != null && item.percent != null) {
      return ['business', 'saleInfo', index, 'percent']
    }
    return []
  })
  formRef.value?.validate(validList)
}
const logisticsProviderInfoValidate = async (rule: Rule, value: number, item: any) => {
  if (props.perfect) {
    if ((value == null || value === 0)) {
      return Promise.reject(new Error('请输入物流商占比'))
    }
  } else {
    if (value == null || value === 0) {
      return (item.currentLogisticsProvider && item.currentLogisticsProvider !== -9) ? Promise.reject(new Error('请输入物流商占比')) : Promise.resolve()
    }
  }
  let result = 0
  if (form.value.business && form.value.business.logisticsProviderInfo) {
    result = form.value.business?.logisticsProviderInfo.reduce(
      (prev: number, curr: any) => calc.Add(prev, Number(curr.percent) || 0),
      0
    )
  }
  if (value && result !== 100) {
    return Promise.reject(new Error('物流商占比总和等于100%'))
  } else {
    return Promise.resolve()
  }
}
const onLogisticsProviderSelect = async (item: any, index: any) => {
  if (item.currentLogisticsProvider === null || item.currentLogisticsProvider === -9) {
    formRef.value?.validate([['business', 'logisticsProviderInfo', index, 'percent']])
  }
}
const onLogisticsProviderInput = async () => {
  const logistics = form.value.business.logisticsProviderInfo
  const validList = logistics?.map((item: any, index: number) => {
    if (item.currentLogisticsProvider != null && item.percent != null) {
      return ['business', 'logisticsProviderInfo', index, 'percent']
    }
    return []
  })
  formRef.value?.validate(validList)
}
const goodsCategoryInfoValidate = async (rule: Rule, value: number, item: any) => {
  if (props.perfect) {
    if ((value == null || value === 0)) {
      return Promise.reject(new Error('请输入品类占比'))
    }
  } else {
    if (value == null || value === 0) {
      return (item.goodsCategory && item.goodsCategory !== -9) ? Promise.reject(new Error('请输入品类占比')) : Promise.resolve()
    }
  }
  if (value == null || value === 0) {
    return Promise.reject(new Error('请输入品类占比'))
  }
  let result = 0
  if (form.value.business && form.value.business.goodsCategoryInfo) {
    result = form.value.business?.goodsCategoryInfo.reduce(
      (prev: number, curr: any) => calc.Add(prev, Number(curr.percent) || 0),
      0
    )
  }
  if (value && result !== 100) {
    return Promise.reject(new Error('品类占比总和等于100%'))
  } else {
    return Promise.resolve()
  }
}
const onGoodsCategorySelect = async (item: any, index: any) => {
  if (item.goodsCategory === null || item.goodsCategory === -9) {
    formRef.value?.validate([['business', 'goodsCategoryInfo', index, 'percent']])
  }
}
const onGoodsCategoryInput = async () => {
  const goodsCategoryInfos = form.value.business.goodsCategoryInfo
  const validList = goodsCategoryInfos?.map((item: any, index: number) => {
    if (item.goodsCategory != null && item.percent != null) {
      return ['business', 'goodsCategoryInfo', index, 'percent']
    }
    return []
  })
  formRef.value?.validate(validList)
}
const status = computed(() => {
  if (route.path.includes('/lbu/potential/add')) {
    // 新增潜在，不能选择无合作可能
    return cloneDeep(dataConfig.potentialStatusEnum).map((item: any) => {
      if (item.value === 13) {
        item.disabled = true
      }
      return item
    })
  } else if (route.path.includes('/lbu/turnToDeal')) {
    // 转成交，不能选择 流失
    // return cloneDeep(dataConfig.clientsEditStatusEnum).map((item: any) => {
    //   if (item.value === 36) {
    //     item.disabled = true
    //   }
    //   return item
    // })
    return cloneDeep(dataConfig.clientsStatusEnum).map((item: any) => {
      const findIndex = dataConfig.clientsEditStatusEnum.findIndex((i: any) => i.value && i.value === item.value)
      item.disabled = findIndex === -1 || item.value === 36
      return item
    })
  }
  if (props.type === 'potential') {
    return dataConfig.potentialStatusEnum
  } else if (props.type === 'clients') {
    return cloneDeep(dataConfig.clientsStatusEnum).map((item: any) => {
      const findIndex = dataConfig.clientsEditStatusEnum.findIndex((i: any) => i.value && i.value === item.value)
      item.disabled = findIndex === -1
      return item
    })
  }
  return []
})
const formRef = ref()
const loading = ref(false)
const channelDisabled = ref(false)
const paramCodeData = ref<any>({
  lbu_customer_business_area: [],
  lbu_sales_category: [],
  lbu_cargo_type: [],
  lbu_logistics_service_provider: [],
  lbu_shipping_channel: [],
  lbu_daily_traffic: [],
  lbu_sale_platform: [],
  lbu_demand_country: [],
  lbu_erp_info: [],
  lbu_department_title: [],
  lbu_customer_grade: [],
  lbu_loss_reason: [],
  lbu_invalid_reason: [],
  lbu_important: [],
  lbu_customer_size: [],
  lbu_source_channel: []
})

// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_lbu',
    paramCodes: [
      'lbu_customer_business_area',
      'lbu_sales_category',
      'lbu_cargo_type',
      'lbu_logistics_service_provider',
      'lbu_shipping_channel',
      'lbu_daily_traffic',
      'lbu_sale_platform',
      'lbu_demand_country',
      'lbu_erp_info',
      'lbu_department_title',
      'lbu_customer_grade',
      'lbu_loss_reason',
      'lbu_invalid_reason',
      'lbu_important',
      'lbu_customer_size',
      'lbu_sign_in_address_label',
      'lbu_source_channel'
    ]
  }).then((res) => {
    if (res.code === 200) {
      if (!props.disabled) {
        // 递归过滤业务参数状态
        res.data = paramCodesDataFilter(res.data, 0)
      }
      paramCodeData.value = res.data

      if (props.isEdit) {
        channelDisabled.value = isChannelDisabled(paramCodeData.value.lbu_source_channel || [], form.value.customerInfo?.channel)
      }
    }
  })
}
onMounted(() => {
  getByParamCodes()
})
const handleSubmit = async () => {
  submitForm(false)
}
const submitForm = async (coverFlag: Boolean) => {
  loading.value = true

  // 清掉无效原因，流失原因
  try {
    let res: any
    let messageTxt: string
    // 地址为空清除、判断地址是否重复
    const p = cloneDeep(form.value)
    if (checkAddressData(form.value.visitAddress)) {
      message.error('签到地址不可重复！')
      loading.value = false
      return false
    }
    p.business.saleInfo = p.business.saleInfo?.filter((item: any) => {
      return item.salePlatformId != null && item.percent != null
    })
    p.business.demandInfo = p.business.demandInfo?.filter((item: any) => {
      const allNull = item.countryId === null && item.amount === null && item.potentialBusinessVolume === null && item.shippingChannel === null
      return !allNull
    })
    p.business.erpInfo = p.business.erpInfo?.filter((item: any) => {
      return item.erpId != null
    })
    p.business.goodsCategoryInfo = p.business.goodsCategoryInfo?.filter((item: any) => {
      return item.goodsCategory != null && item.percent != null
    })
    p.business.logisticsProviderInfo = p.business.logisticsProviderInfo?.filter((item: any) => {
      return item.currentLogisticsProvider != null && item.percent != null
    })
    p.business.tpr = p.business.demandInfo?.reduce((sum: number, item: any) => {
      if (item.amount != null) {
        return calc.Add(sum, item.amount || 0)
      }
      return calc.Add(sum, 0)
    }, 0)
    p.business.totalPotential = p.business.demandInfo?.reduce((sum: number, item: any) => {
      if (item.potentialBusinessVolume != null) {
        return calc.Add(sum, item.potentialBusinessVolume || 0)
      }
      return calc.Add(sum, 0)
    }, 0)
    const { visitAddress } = p
    p.visitAddress = clear(visitAddress, ['addressName'])
    // 新增、编辑的格式和详情不同、多传attrList
    if (JSON.stringify(p.visitAddress) === '[{}]') {
      p.visitAddress = { attrList: [] }
    } else {
      p.visitAddress = { attrList: p.visitAddress }
    }
    if (route.path.includes('/lbu/turnToDeal')) {
      res = await turnedDeal(
        {
          ...p,
          coverFlag // 是否覆盖客户
        },
        { custom: { errorMsg: false } }
      )
      messageTxt = '转成交成功'
    } else {
      if (route.query.cosId) {
        // 处理联系人关联ID
        const { contact, customerInfo } = form.value
        if (!contact.contactRefId) {
          contact.contactRefId = customerInfo?.cosId
        }
        res = await potentialEdit(
          {
            ...p,
            coverFlag // 是否覆盖客户
          },
          { custom: { errorMsg: false } }
        )
        messageTxt = '编辑成功'
      } else {
        res = await potentialAdd(
          {
            ...p,
            coverFlag // 是否覆盖客户
          },
          { custom: { errorMsg: false } }
        )
        messageTxt = '新增成功'
      }
    }
    // 判断名称是否重复
    if (res.code === 12000025) {
      DcConfirm.warning({
        title: '操作提示！',
        content: '系统内已有相同客户名的数据，是否继续添加？',
        cancelText: '取消',
        okText: '继续',
        onOk() {
          submitForm(true)
        }
      })
    } else if (res.code === 200) {
      DcMessage.success(messageTxt)
      goBack()
    } else {
      DcMessage.error(res.message)
    }
  } catch (error) {}
  loading.value = false
}
// 新增列
const handleAddCol = (arr: {}[]) => {
  arr.push({})
}
// 删除列
const handleDelCol = (arr: {}[], index: number) => {
  arr.splice(index, 1)
}
</script>
<script lang="ts">
export default { name: 'customerCenterBaseMessage' }
</script>
<style lang="scss"></style>
